export default {
  base(
    method,
    url,
    data,
    config = { headers: {} },
  ) {
    return new Promise((resolve, reject) => {
      const params = {
        ...data,
      };
      let paramsStr;
      if (method === 'GET') {
        paramsStr = Object.keys(params)
          .map((key) => `${key}=${params[key]}`).join('&');
      } else {
        paramsStr = JSON.stringify(params);
      }

      const http = new window.XMLHttpRequest();
      http.open(method, url, true);
      http.setRequestHeader('Content-type', 'application/json');

      const { headers = {} } = config;
      Object.keys(headers).forEach((key) => {
        http.setRequestHeader(key, headers[key]);
      });

      http.onreadystatechange = () => {
        if (http.readyState === 4) {
          if (http.status !== 200) {
            reject(http);
            return;
          }
          const contentType = http.getResponseHeader('Content-Type');
          if (contentType && contentType.indexOf('application/json') >= 0) {
            try {
              const res = JSON.parse(http.responseText);
              const { status, code, msg } = res;
              if (Number(code) === 0 || Number(status) === 1) {
                resolve(res);
              } else {
                const err = new Error(msg);
                err.response = res;
                err.code = code;
                reject(err);
              }
            } catch (ex) {
              reject(new Error(http.responseText));
            }
          } else {
            reject(new Error(http.responseText));
          }
        }
      };
      http.send(paramsStr);
    });
  },

  post(url, data, config) {
    return this.base('POST', url, data, config);
  },

  get(url, data, config) {
    return this.base('GET', url, data, config);
  },
};
